import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import DirectEmissions41_1cTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const DirectEmissions41_1c = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("DIRECT_EMISSIONS_USE") || "Indicate whether your product consumes fuels and electricity during use"}
        subDescription={t("DIRECT_EMISSIONS_41_1C_DESC") || "Direct emissions from use"}
        isNormal={true}
        number={"41.1c"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`direct-emissions-41-1c-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <DirectEmissions41_1cTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default DirectEmissions41_1c;


